export default __webpack_public_path__ + "static/media/Saly-10.00dddc15.png";